import { isSSR } from '~/src/common/utilities';

import { useHasMounted } from './useHasMounted';

export function useIsSSR() {
  const { hasMounted } = useHasMounted();
  const isFirstRender = !hasMounted;
  return isSSR() || isFirstRender;
}
